<template>
  <div>
    <div v-if="!isLoading" class="container-fluid meeting-register-component">
      <b-row class="mb-5">
        <b-col cols="12">
          <div class="d-flex justify-content-center justify-content-sm-start pt-3">
            <img class="img-logo" alt="Domeo - assemblées" src="../../assets/images/logo.png" />
            <div class="meeting-details ml-4">
              <h3>{{ meeting.name }}</h3>
              <h5>{{ building.name }}</h5>
              <div>Date: {{ $moment(meeting.meeting_date).format("DD/MM/YYYY HH[h]mm") }}</div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="meeting-details-col">
          <div class="d-flex pt-3">
            <div class="ml-2">
              <h3>{{ meeting.name }}</h3>
              <h5>{{ building.name }}</h5>
              <div>Date: {{ $moment(meeting.meeting_date).format("DD/MM/YYYY HH[h]mm") }}</div>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Step 1 Select Participant -->
      <b-row v-if="!isParticipantSelected && !viewContact" class="meeting-register-multiselect">
        <b-col cols="12" md="6">
          <label class="text-uppercase"><h5>Ajouter un participant</h5></label>
          <div class="p-4 bg-color-gray-light rounded">
            <v-multiselect
              ref="multiselect-participants"
              :show-labels="false"
              :options="addParticipantsOptions"
              group-values="items"
              group-label="group"
              :group-select="false"
              placeholder="Tapez pour rechercher"
              track-by="identifier"
              label="search"
              open-direction="bottom"
              :close-on-select="false"
              @open="toggleMainMultiselect"
              @close="toggleMainMultiselect"
            >
              <template slot="option" slot-scope="props">
                <div v-if="props.option.$groupLabel" class="select-option-group-label">
                  <strong class="color-green-darker">{{ props.option.$groupLabel }}</strong>
                </div>
                <div
                  v-else
                  class="select-option-item"
                  @click="onSelectOwnerOrContact(props.option, 'physical')"
                >
                  <div v-if="props.option.type == 'owner'">
                    <div class="select-option-main d-flex align-items-center">
                      <span class="mr-2">
                        {{ props.option.name }}
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <div class="select-option-main">
                      {{ props.option.name }}
                    </div>
                  </div>
                </div>
              </template>
              <template slot="beforeList">
                <div class="select-beforeList-buttons">
                  <div
                    v-if="meeting.allowed_modalities.physical"
                    class="btn w-100 d-flex"
                    type="button"
                    @click="openCreateContact"
                  >
                    <div
                      class="border-green-darker rounded-circle px-1 d-flex justify-content-center align-items-center"
                    >
                      <font-awesome-icon icon="plus" class="color-green-darker" />
                    </div>
                    <div class="ml-2">
                      Ajouter une nouvelle contact.
                    </div>
                  </div>
                </div>
              </template>
              <span slot="noResult" class="mx-2">
                Oops! Aucun élément trouvé. Pensez à modifier la requête de recherche.
              </span>
            </v-multiselect>
          </div>
        </b-col>
        <b-col cols="12" md="6" class="mt-4 mt-md-0">
          <label class="text-uppercase"><h5>Scanner le code</h5></label>
          <div
            class="d-flex justify-content-center align-items-center flex-column border bg-color-gray-light rounded"
          >
            <div v-if="!isQrScannerOpen" class="my-5">
              <div type="button" class="btn bg-white p-3 rounded" @click="openQrScanner">
                <font-awesome-icon icon="qrcode" size="5x" />
              </div>
            </div>
            <div v-else class="mb-2 w-100 text-right mr-2 mt-2 pr-1">
              <div type="button" class="btn color-dark" @click="openQrScanner">
                <font-awesome-icon icon="times" size="lg" />
              </div>
            </div>
            <qrcode-stream
              v-if="isQrScannerOpen"
              class="px-4 pb-4"
              :camera="camera"
              @decode="onDecode"
              @init="onInit"
            >
              <div v-if="isQrScannerLoading" class="loading-indicator">
                <appLoader />
              </div>
              <div v-if="qrScannerPermissionDenied" class="validation-failure text-center">
                <span> Veuillez donner accès à votre caméra !</span>
              </div>
            </qrcode-stream>
          </div>
        </b-col>
      </b-row>
      <!-- Step 2 See participant data/create contact and select representant -->
      <appPresenceTable
        v-if="meeting.allowed_modalities.physical && isParticipantSelected"
        class="meeting-register-presence-table"
        :presence-mandates="allMandates"
        :selected-contact="selectedContact"
      />
      <contact
        v-if="viewContact"
        class="px-5"
        :agency="meeting.agency_id"
        :building-id="building.id"
        @cancel="closeCreateContact"
        @setContact="setContact"
      ></contact>
      <b-row>
        <b-col v-if="isParticipantSelected && !areChangesValidated" cols="12">
          <div class="d-flex justify-content-end">
            <div
              class="btn btn-simple bg-color-green-darker color-white mt-3"
              @click="validateAllChanges"
            >
              Valider
            </div>
          </div>
        </b-col>
        <b-col v-if="areChangesValidated" cols="12">
          <div
            class="d-flex flex-column flex-lg-row justify-content-center align-items-center align-items-lg-start mt-5"
          >
            <div class="border rounded shadow-sm mb-5" :style="signaturePadContainerSize">
              <VueSignaturePad ref="signaturePad" width="100%" height="100%" />
              <div v-if="signatureDataError" class="text-danger mt-1 text-center">
                Veuillez ajouter une signature !
              </div>
            </div>
            <div class="d-flex flex-column align-items-center align-items-lg-start ml-sm-5">
              <div class="btn btn-simple mb-3 bg-color-gray-3 color-white" @click="clearSignature">
                Effacer
              </div>
              <div class="btn btn-simple bg-color-green-darker color-white" @click="saveSignature">
                Signer et terminer
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <appLoader v-else />
    <!-- Modal Ask Building Owner -->
    <b-modal
      id="modal-ask-building-owner"
      size="lg"
      hide-footer
      centered
      @close="onModalAskBoClose"
    >
      <modalAskBuildingOwner
        class="meeting-register-multipleselect-owners"
        :options="assignBuildingOwnerOptions"
        @setMandate="setMandate"
        @onOpenSelect="showAskBuildingOwnerMultiselect = true"
        @onCloseSelect="showAskBuildingOwnerMultiselect = false"
      />
      <div v-if="!isQrScannerContactOpen" class="my-5 d-flex flex-column justify-content-center">
        <div class="text-center">Cliquez ici pour scanner le code QR</div>
        <div
          type="button"
          class="btn bg-white p-3 rounded text-center"
          @click="openQrScannerContact"
        >
          <font-awesome-icon icon="qrcode" size="5x" />
        </div>
      </div>
      <div v-else class="mb-2 w-100 text-right mr-2 mt-4 pr-1">
        <div type="button" class="btn color-dark" @click="openQrScannerContact">
          <font-awesome-icon icon="times" size="lg" />
        </div>
      </div>
      <qrcode-stream
        v-if="isQrScannerContactOpen"
        class="px-4 pb-4"
        :camera="camera"
        @decode="onDecodeContact"
        @init="onInitContact"
      >
        <div v-if="isQrScannerContactLoading" class="loading-indicator">
          <appLoader />
        </div>
        <div v-if="qrScannerContactPermissionDenied" class="validation-failure text-center">
          <span> Veuillez donner accès à votre caméra !</span>
        </div>
      </qrcode-stream>
    </b-modal>
  </div>
</template>
<script>
import MeetingMW from "@/middlewares/Meeting";
import MajorityMW from "@/middlewares/Majority";
import ContactMW from "@/middlewares/Contact";
import VotingCategoryMW from "@/middlewares/VotingCategory";
import BuildingOwnerMW from "@/middlewares/BuildingOwner";
import BuildingLotMW from "@/middlewares/BuildingLot";
import BuildingMW from "@/middlewares/Building";
import MeetingRegisterMW from "@/middlewares/MeetingRegister";

import MeetingORM from "@/store/orm-axios/models/Meeting";
import MandateORM from "@/store/orm-axios/models/Mandate";
import ContactORM from "@/store/orm-axios/models/Contact";
import BuildingORM from "@/store/orm-axios/models/Building";

import appBOTantiemes from "@/components/snippets/BuildingOwnerTantiemes";
import modalAskBuildingOwner from "@/components/modals/create-contact/AskBuildingOwner";
import contact from "@/components/meetings/meeting-register/ContactForm";

import meetingDetailsMixin from "@/mixins/meeting-details";
import meetingPresenceSelectOptionsMixins from "@/mixins/meeting-presence-select-options";
import minutesMixin from "@/mixins/minutes";
import votingLimitRulesMixin from "@/mixins/voting-limit-rules";
import mercureMixin from "@/mixins/mercure-live-changes/meeting-register";

import { meetingMinutesNames, meetingStatuses } from "@/constants/meeting.js";

import { QrcodeStream, QrcodeDropZone } from "vue-qrcode-reader";
import { VueSignaturePad } from "vue-signature-pad";

var uuid = require("uuid");

export default {
  components: {
    appPresenceTable: () =>
      import("@/components/meetings/meeting-presence/MeetingRegisterPresence"),
    appBOTantiemes,
    modalAskBuildingOwner,
    contact,
    QrcodeStream,
    QrcodeDropZone,
    VueSignaturePad,
  },
  mixins: [
    meetingDetailsMixin,
    meetingPresenceSelectOptionsMixins,
    minutesMixin,
    votingLimitRulesMixin,
    mercureMixin,
  ],
  data() {
    return {
      isLoading: false,
      meetingMinutesNames,
      meetingStatuses,
      meetingId: null,
      timezone: "Europe/Paris",
      addParticipantsOptions: [],
      selectedOwnerOrContact: null,
      selectedOwnerOrContactPresenceType: "physical",
      showAskBuildingOwnerMultiselect: false,
      assignBuildingOwnerOptions: [],
      viewContact: false,
      camera: "auto",
      signatureData: null,
      signatureDataError: false,
      isQrScannerOpen: false,
      isQrScannerLoading: false,
      qrScannerPermissionDenied: false,
      mainMandateId: null,
      isParticipantSelected: false,
      areChangesValidated: false,
      selectedContact: {},
      signaturePadContainerSize: "width: 300px; height: 250px;",
      isQrScannerContactOpen: false,
      isQrScannerContactLoading: false,
      qrScannerContactPermissionDenied: false,
    };
  },
  computed: {
    meeting() {
      return MeetingORM.getters("getById")(this.meetingId);
    },
    buildingComputed() {
      return BuildingORM.getters("getById")(this.meeting.building_id);
    },
    allMandates() {
      return MandateORM.getters("getMandatesForMeetingPresence")(this.meeting.id);
    },
    mainMandate() {
      return MandateORM.query()
        .where("meeting_id", this.meetingId)
        .where("presence_status", this.mandatePresenceStatuses.physical)
        .where("showed_up", 1)
        .where("is_selected", true)
        .first();
    },
    mainContact() {
      return ContactORM.query().where("id", this.selectedContact.id).first();
    },
    isMercureJwtTokenInvalid() {
      return this.$store.getters["auth/isMercureJwtTokenInvalid"];
    },
  },
  watch: {
    showMainMultiselect(val) {
      if (val) {
        this.addParticipantsOptions = this.getBOsCsNotShowUpNotIntendToOrNotRepresentedGroupedOpts();
      } else {
        this.addParticipantsOptions = [];
      }
    },
    showAskBuildingOwnerMultiselect(val) {
      if (val) {
        this.assignBuildingOwnerOptions = this.getBOsNotShowedUpOrRepresentedOpts();
      } else {
        this.assignBuildingOwnerOptions = [];
      }
    },
    mainMandate(newValue) {
      if (!newValue) {
        this.isParticipantSelected = false;
        this.areChangesValidated = false;
      }
    },
    mainContact(newValue) {
      if ((newValue && !newValue.is_selected) || !newValue) {
        this.isParticipantSelected = false;
        this.areChangesValidated = false;
      }
    },
    meeting(newValue) {
      if (
        newValue.status !== null &&
        newValue.status !== this.meetingStatuses.invitationSent &&
        newValue.status !== this.meetingStatuses.started
      ) {
        this.$swal(this.alertError(null, "L'accès à cette réunion n'est plus autorisé", 3500)).then(
          () => {
            this.$router.push({ name: "login" });
          }
        );
      }
    },
  },
  async created() {
    this.meetingId = this.$route.params.id;
    if (this.$route.query.tz) this.timezone = this.$route.query.tz;

    this.isLoading = true;
    await MeetingMW.REGISTER(this.meetingId).then(async () => {
      localStorage.setItem("mercure-jwt-token", this.meeting.mercure_jwt_token);
      this.initMeetingRegisterMercure();
      this.building = { ...this.buildingComputed };
    });
    await this.makeApiCalls().then(() => {
      const generalDetailsEvent = this.meeting.minutes.find(
        minute => minute.event == this.meetingMinutesNames.general_details
      );
      const hasFreezedMeetingDetails = !this.$_.isEmpty(this.meeting.freezed_meeting_details);
      this.setMeetingDetailsStoreVariables(hasFreezedMeetingDetails);
      this.setVotingLimitRulesStoreVariables(generalDetailsEvent);
      this.addParticipantsOptions = this.getBOsCsNotShowUpNotIntendToOrNotRepresentedGroupedOpts();
      this.isLoading = false;
      this.isQrScannerOpen = true;
    });
    this.$moment.tz.setDefault(this.timezone);

    let width = screen.width;
    if (width > 300 && width <= 400) {
      this.signaturePadContainerSize = "width: 100%; height: 250px;";
    } else if (width > 400 && width <= 991) {
      this.signaturePadContainerSize = "width: 100%; height: 350px;";
    }
  },
  methods: {
    async makeApiCalls() {
      return Promise.all([
        // NOTE: Majorities are already changed based on relation from BuildingMajority
        await MajorityMW.REGISTER_GET_MAJORITIES(this.meetingId),
        await ContactMW.REGISTER_GET_CONTACTS(this.meetingId),
        await VotingCategoryMW.REGISTER_GET_VOTING_CATEGORIES(this.meetingId),
        await BuildingOwnerMW.REGISTER_GET_BUILDING_OWNERS(this.meetingId),
        await BuildingLotMW.REGISTER_GET_BUILDING_LOTS(this.meetingId),
        await BuildingMW.REGISTER_GET_BUILDING(this.meetingId),
      ]);
    },
    toggleMainMultiselect() {
      this.showMainMultiselect = !this.showMainMultiselect;
      if (this.showMainMultiselect) {
        this.addParticipantsOptions = this.getBOsCsNotShowUpNotIntendToOrNotRepresentedGroupedOpts();
      }
    },
    onSelectOwnerOrContact(selectedOwnerOrContact, selectedOwnerOrContactPresenceType) {
      this.$refs["multiselect-participants"].isOpen = false;
      this.showMainMultiselect = false;
      this.selectedOwnerOrContact = selectedOwnerOrContact;
      this.selectedOwnerOrContactPresenceType = selectedOwnerOrContactPresenceType;

      if (selectedOwnerOrContact.type == "contact") {
        this.$bvModal.show("modal-ask-building-owner");
      } else if (selectedOwnerOrContact.type == "owner") {
        this.ADD_MANDATE(selectedOwnerOrContact.id);
      }
    },
    async setMandate(buildingOwnerId) {
      this.$bvModal.hide("modal-ask-building-owner");

      await this.ADD_MANDATE(buildingOwnerId, true, false);

      var hasOtherPouvoirsAssigned = this.checkIfContactHasOtherPouvoirsAssigned(
        this.selectedOwnerOrContact.id,
        buildingOwnerId
      );
      for (let mandate of hasOtherPouvoirsAssigned) {
        await this.ADD_MANDATE(mandate.building_owner_id, false, false);
      }

      this.updateMeetingMinutes();
    },
    async ADD_MANDATE(buildingOwnerId, setContactArrivedEvent = true, updateMeetingMinutes = true) {
      try {
        this.isParticipantSelected = true;

        var defaultMandate = MandateORM.query()
          .where("meeting_id", this.meeting.id)
          .where("building_owner_id", buildingOwnerId)
          .first();

        this.mainMandateId = defaultMandate.id;

        // set mandate representant id
        defaultMandate.showed_up = 1;
        defaultMandate.representant_contact_id =
          this.selectedOwnerOrContact.type == "contact" ? this.selectedOwnerOrContact.id : null;
        defaultMandate.representant_owner_id =
          this.selectedOwnerOrContact.type == "owner" ? this.selectedOwnerOrContact.id : null;

        // set mandate presence status
        if (defaultMandate.representant_owner_id == defaultMandate.building_owner_id) {
          defaultMandate.presence_status = this.mandatePresenceStatuses.physical;
        } else if (defaultMandate.representant_owner_id || defaultMandate.representant_contact_id) {
          defaultMandate.presence_status = this.mandatePresenceStatuses.pouvoir;
        } else if (
          defaultMandate.representant_owner_id == null &&
          defaultMandate.representant_contact_id == null
        ) {
          defaultMandate.presence_status = this.mandatePresenceStatuses.not_present;
        }

        defaultMandate.is_selected = true;

        // NOTE: for meeting minutes (participant-arrived event)
        MandateORM.update({
          where: defaultMandate.id,
          data: defaultMandate,
        });
        if (this.selectedOwnerOrContact.type == "contact") {
          if (setContactArrivedEvent)
            await this.setContactArrivedEvent(this.selectedOwnerOrContact.id);
          await this.setMandateAddedEvent(defaultMandate.id, false);
        } else {
          await this.setParticipantArrivedEvent(defaultMandate.id, false);
        }

        if (updateMeetingMinutes) {
          this.updateMeetingMinutes();
        }

        // NOTE: Set new contact or remove old one
        if (this.selectedOwnerOrContact.type == "contact") {
          let contact = ContactORM.query().where("id", this.selectedOwnerOrContact.id).first();
          contact.is_selected = true;
          ContactORM.update({
            where: contact.id,
            data: contact,
          });
          this.selectedContact = contact;
        } else {
          this.selectedContact = {};
        }
      } catch (err) {
        console.error(err);
        this.$swal(this.alertError());
      }
    },
    checkIfContactHasOtherPouvoirsAssigned(contactId, buildingOwnerId) {
      return MandateORM.query()
        .where(mandate => {
          return (
            mandate.meeting_id == this.meeting.id &&
            mandate.representant_contact_id == contactId &&
            mandate.building_owner_id != buildingOwnerId &&
            mandate.presence_status == null
          );
        })
        .get();
    },
    updateMeetingMinutes() {
      var m = MeetingORM.find(this.meeting.id);
      MeetingORM.update({
        where: m.id,
        data: m,
      });
    },
    openCreateContact() {
      this.viewContact = true;
      this.$refs["multiselect-participants"].isOpen = false;
    },
    closeCreateContact() {
      this.viewContact = false;
    },
    setContact(contact) {
      this.selectedOwnerOrContact = {
        type: "contact",
        id: contact.id,
      };
      this.closeCreateContact();
      this.$bvModal.show("modal-ask-building-owner");
    },
    setOwnerDataFromQrCode(ownerId) {
      this.selectedOwnerOrContact = {
        type: "owner",
        id: ownerId,
      };
      let mandate = MandateORM.query()
        .where("meeting_id", this.meeting.id)
        .where("building_owner_id", this.selectedOwnerOrContact.id)
        .first();

      if (!mandate) {
        this.$swal(this.alertError("", "Ce propriétaire n'appartient pas à cet immeuble.", 3000));
      } else {
        this.ADD_MANDATE(this.selectedOwnerOrContact.id);
      }
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.signatureData = data;
      } else {
        this.signatureDataError = true;
        return;
      }
      this.signatureDataError = false;
      // NOTE: After document sign
      this.saveChanges();
    },
    saveChanges() {
      let validate = this.validateCheckedRepresentatives();
      if (!validate) {
        return;
      }

      this.isLoading = true;

      let mandates = MandateORM.query()
        .where("meeting_id", this.meeting.id)
        .where("is_selected", true)
        .get();

      let object = {
        meetingId: this.meeting.id,
        meeting: this.meeting,
        mandates: mandates,
        base64Signature: this.signatureData,
        mainMandateId: this.mainMandateId,
        mainContactId: this.mainContact ? this.mainContact.id : null,
        contactData: this.mainContact,
        timezone: this.timezone,
        agencyId: this.meeting.agency_id,
      };
      MeetingRegisterMW.POST(object)
        .then(res => {
          this.isLoading = false;
          if (res.response && res.response.data && res.response.data.status == "access-denied") {
            this.$swal(
              this.alertError(null, "L'accès à cette réunion n'est plus autorisé", 3500)
            ).then(() => {
              this.$router.push({ name: "login" });
            });
          } else {
            this.$swal(this.alertSuccess(null, "Opération fait avec succès", 3000));
            this.resetMeetingRegisterProcess();
          }
        })
        .catch(err => {
          this.isLoading = false;
          console.error(err);
          this.$swal(
            this.alertError(
              null,
              "Erreur lors de l'enregistrement du participant. Veuillez vérifier votre connexion et réessayer.",
              5000
            )
          );
        });
    },
    validateAllChanges() {
      let validate = this.validateCheckedRepresentatives();
      if (validate) {
        this.areChangesValidated = true;
      }
    },
    resetMeetingRegisterProcess() {
      this.isParticipantSelected = false;
      this.areChangesValidated = false;
      this.mainMandateId = null;
      this.selectedContact = {};
      let mandates = MandateORM.query().where("meeting_id", this.meeting.id).get();
      mandates.forEach(mandate => {
        mandate.is_selected = false;
        MandateORM.update({
          where: mandate.id,
          data: mandate,
        });
      });
      let contacts = ContactORM.query().where("building_id", this.building.id).get();
      contacts.forEach(contact => {
        contact.is_selected = false;
        ContactORM.update({
          where: contact.id,
          data: contact,
        });
      });
    },
    validateCheckedRepresentatives() {
      let validate = true;
      let mandates = MandateORM.query().where("meeting_id", this.meeting.id).get();
      if (this.mainMandate) {
        let mandatesSelected = this.$_.filter(mandates, mandate => {
          return (
            mandate.is_selected &&
            mandate.presence_status != this.mandatePresenceStatuses.pouvoir &&
            mandate.showed_up != 1 &&
            mandate.id != this.mainMandate.id
          );
        });
        let mandatesChecked = this.$_.filter(mandates, mandate => {
          return (
            mandate.is_selected &&
            mandate.presence_status == this.mandatePresenceStatuses.pouvoir &&
            mandate.showed_up == 1 &&
            mandate.id != this.mainMandate.id
          );
        });
        if (mandatesSelected.length > 0 && mandatesChecked.length == 0) {
          validate = false;
          this.$swal(
            this.alertWarning(
              "",
              "Vous avez ajouté des représentants dans la liste mais vous n'en avez sélectionné aucun."
            )
          );
        }
      } else if (this.mainContact) {
        let mandatesSelected = this.$_.filter(mandates, mandate => {
          return (
            mandate.is_selected && mandate.presence_status != this.mandatePresenceStatuses.pouvoir
          );
        });
        let mandatesChecked = this.$_.filter(mandates, mandate => {
          return (
            mandate.is_selected &&
            mandate.presence_status == this.mandatePresenceStatuses.pouvoir &&
            mandate.representant_contact_id == this.mainContact.id
          );
        });
        if (mandatesSelected.length > 0 && mandatesChecked.length == 0) {
          validate = false;
          this.$swal(
            this.alertWarning(
              "",
              "Vous avez ajouté des représentants dans la liste mais vous n'en avez sélectionné aucun."
            )
          );
        } else if (mandatesSelected.length == 0 && mandatesChecked.length == 0) {
          validate = false;
          this.$swal(this.alertWarning("", "Vous n'avez pas ajouté de représentants à la liste."));
        }
      }
      return validate;
    },
    openQrScanner() {
      this.isQrScannerOpen = !this.isQrScannerOpen;
    },
    async onInit(promise) {
      this.isQrScannerLoading = true;
      this.qrScannerPermissionDenied = false;
      try {
        await promise;
      } catch (e) {
        console.error(e);
        let errorToString = e.toString();
        let error = errorToString.includes("Permission denied");
        if (error) {
          this.qrScannerPermissionDenied = true;
        }
      } finally {
        this.isQrScannerLoading = false;
      }
    },
    async onDecode(content) {
      this.isQrScannerOpen = false;
      try {
        this.setOwnerDataFromQrCode(content);
      } catch (error) {
        this.$swal(this.alertError("", "Le code QR n'est pas correct !", 2000));
      }
    },

    openQrScannerContact() {
      this.isQrScannerContactOpen = !this.isQrScannerContactOpen;
      this.isQrScannerOpen = false;
    },
    async onInitContact(promise) {
      this.isQrScannerContactLoading = true;
      this.qrScannerContactPermissionDenied = false;
      try {
        await promise;
      } catch (e) {
        console.error(e);
        let errorToString = e.toString();
        let error = errorToString.includes("Permission denied");
        if (error) {
          this.qrScannerContactPermissionDenied = true;
        }
      } finally {
        this.isQrScannerContactLoading = false;
      }
    },
    async onDecodeContact(content) {
      this.isQrScannerContactOpen = false;
      try {
        this.setMandate(content);
      } catch (error) {
        this.$swal(this.alertError("", "Le code QR n'est pas correct !", 2000));
      }
    },
    onModalAskBoClose() {
      // NOTE: Remove only if the contact is not existent in DB
      if (this.selectedOwnerOrContact.type == "contact") {
        if (!uuid.validate(this.selectedOwnerOrContact.id)) {
          ContactORM.delete(this.selectedOwnerOrContact.id);
          this.$store.commit(
            "meetingDetails/deleteMeetingDetailsContactsDataItem",
            this.selectedOwnerOrContact.id
          );
          this.setFreezedMeetingDetailsInMeeting(false);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.img-logo {
  height: 80px;
  // width: 150px;
}
</style>
